import React from 'react';
import IconTransfer from 'design-system/icons/IconTransfer';
import useColors from 'hooks/useColors';
import { IconBoldArrow } from 'design-system/icons';
export const SmartRuleIconForTransactionType = ({ type, ...props }) => {
    const colors = useColors();
    switch (type) {
        case 'income':
            return (<IconBoldArrow alt color={colors.text.income} direction="right" {...props}/>);
        case 'spending':
            return (<IconBoldArrow alt color={colors.elements.feed} direction="left" {...props}/>);
        default:
            return <IconTransfer color={colors.status.informational} {...props}/>;
    }
};
